import "./Contact.css";

function Contact() {
  return (
    <section id="contact" className="contact">
      <h2>Contact Us</h2>
      <p>
        Interested in product pricing or details?  
        Please fill out the form below and our team will get back to you.
      </p>

      <form className="contact-form">
        <input
          type="text"
          placeholder="Your Name"
          required
        />

        <input
          type="email"
          placeholder="Your Email"
          required
        />

        <input
          type="text"
          placeholder="Product Name"
        />

        <textarea
          placeholder="Your Message"
          rows="4"
        ></textarea>

        <button type="submit">
          Submit Request
        </button>
      </form>
    </section>
  );
}

export default Contact;
